import { useTranslation } from "react-i18next";
import { ContentPanel, PageBanner, UnorderedList } from "../components";
import { MedevacServicesBanner } from "../images";

export const MedevacServices = () => {
    const { t } = useTranslation();
    const keyFeatures = t('medevacServices.keyFeatures', { returnObjects: true }) as string[]

    return (
        <div>
            <PageBanner image={MedevacServicesBanner} title={t('medevacServices.bannerTitle')} />

            <ContentPanel headerText={t('medevacServices.header')}>
                <h4 className="text-xl mb-5">{t('generic.keyFeatures')}</h4>

                <UnorderedList items={keyFeatures} />

                <h4 className="text-xl my-5">{t('generic.criticalFor')}</h4>
                <span className="text-white leading-relaxed">{t('medevacServices.critialFor')}</span>
            </ContentPanel>
        </div>
    )
}